import Main from './Main.vue'

const routes = [
  {
    name: 'database',
    component: Main,
    path: '/database',
    meta: {
      requiresAuth: true,
    },
  },
]

export { routes }
